import React from 'react';
import { Redirect, Stack, useSegments } from 'expo-router';
import type { Href } from 'expo-router';
import { View, ActivityIndicator } from 'react-native';
import { useAuth } from '../../src/context/AuthContext';
import { canRenderGatedRoute } from '../../src/navigation/gatedAccess';
import { pathForPhase } from '../../src/navigation/phaseRedirect';

export default function GatedLayout() {
  const { phase } = useAuth();
  const segments = useSegments();
  const routeLeaf = segments[segments.length - 1];
  const phasePath = pathForPhase(phase);

  // Guard BEFORE rendering gated screens (was a post-render useEffect, which
  // let the wrong screen flash before redirecting).
  if (phase === 'loading') {
    return (
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: '#f8fafc' }}>
        <ActivityIndicator size="large" color="#2563eb" />
      </View>
    );
  }

  if (!canRenderGatedRoute(phase, routeLeaf)) {
    return <Redirect href={phasePath as Href} />;
  }

  return <Stack screenOptions={{ headerShown: false }} />;
}
